import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ISite, SiteModel } from '../../shared/models';
import { map } from 'rxjs/operators';
import { arrayOfType } from '../../shared/utils/data.utils';

@Injectable({
  providedIn: 'root',
})
export class SitesService {
  constructor(private readonly httpClient: HttpClient) {}

  getAllSites(): Observable<ISite[]> {
    return this.httpClient
      .get<ISite[]>(`/api/Lhlhapi/GetAllSitesByUserIdJson`)
      .pipe(map((sites) => arrayOfType<ISite>(sites, SiteModel)));
  }
}
